import { Locale } from "modules/i18n/locale-config";
import { extendTranslation } from "../../../brand-utils";
import defaultTranslation from "../../default/messages/sv";

export default extendTranslation(defaultTranslation, {
  locale: Locale.SV.code,
  messages: {
    "root.title": "DIGITAL REHAB &<br/> PREHAB",
    "root.titleSecond": "SJÄLVSKATTNING",
    "root.desc": `Välkommen att starta din resa till smärtfrihet.<br/>
      Resan börjar med en <b>självskattning</b> (tar ett par minuter).`,
    "locale-switcher.title": "Språk"
  }
});


// WEBPACK FOOTER //
// ./src/modules/brand/brands/dif/messages/sv.js